import { put, takeEvery } from "redux-saga/effects";
import axiosCustom from "../../../components/common/apiConfigPouyan/index";
import { notificationAlertErrorApi } from "../../../components/method/notificationAlertErrorApi/notificationAlertErrorApi";

export const actionTypes = {
  GetBranch: "[GetBranch] Action",
  GetBranchAsync: "[GetBranchAsync] Action",
  GetBranchLoading: "[GetBranchLoading] Action",
};

const initialState = {
  data: [],
  loading: false,
};

export const get_branches_reducer = (
  state = initialState,
  { type, payload },
) => {
  switch (type) {
    case actionTypes.GetBranch:
      return {
        data: payload ? payload : [],
      };
    case actionTypes.GetBranchLoading:
      return {
        ...state,
        loading: payload,
      };

    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  const config = {
    url: `/Branch/GetBranches`,
    method: "GET",
  };

  const data = {
    ...payload?.data,
  };

  const header = {
    ...payload?.headers,
  };
  yield put({ type: actionTypes.GetBranchLoading, payload: true });
  try {
    let res = yield axiosCustom(config, data, header);

    if (res?.data?.data)
      yield put({
        type: actionTypes.GetBranch,
        payload: res?.data?.data.sort((a, b) => b.order - a.order),
      });
  } catch (error) {
    notificationAlertErrorApi(error, payload?.dispatch);
  } finally {
    yield put({ type: actionTypes.GetBranchLoading, payload: false });
  }
}

export function* get_branches_worker() {
  yield takeEvery(actionTypes.GetBranchAsync, handleWorker);
}
